import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { HotKeys } from 'react-hotkeys';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import { contextType } from 'types';

import map from 'lodash/map';

import Form from 'components/Form';

import {
  getContextBlocksValues,
  getIsUpdating,
} from 'store/services/contexts/selectors';
import {
  checkContextName,
  partialExportSingleContext,
  deselectContext,
} from 'store/services/contexts/actions';

import FORM_NAMES from 'constants/formNames';

import ContextInspectHeader from './components/ContextInspectHeader';
import ContextInspectForm from './components/ContextInspectForm';

import validate from './utils';

import './style.scss';

const keyMap = {
  leave: 'esc',
};

export class ContextInspect extends Component {
  static propTypes = {
    id: PropTypes.string,
    context: contextType,
    isLoading: PropTypes.bool,
    isUpdating: PropTypes.bool,
    onSubmit: PropTypes.func,
    onDelete: PropTypes.func,
    onSelect: PropTypes.func,
    onClose: PropTypes.func,
    handleSubmit: PropTypes.func,
    partialExport: PropTypes.func.isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    checkContextName: PropTypes.func,
    // REDUX-FORM:
    invalid: PropTypes.bool.isRequired,
    dirty: PropTypes.bool.isRequired,
    submit: PropTypes.func.isRequired,
    deselectContext: PropTypes.func.isRequired,
  };

  static defaultProps = {
    context: {},
  };

  componentDidMount = () => {
    const { id } = this.props;

    if (id) {
      this.props.onSelect(id);
    }
  };

  componentWillReceiveProps = ({ id }) => {
    if (this.props.id !== id) {
      this.props.onSelect(id);
    }
  };

  componentWillUnmount = () => {
    this.props.deselectContext();
  };

  keyHandlers = {
    leave: e => {
      e.cancelBubble = true;
      this.handleCloseRequest();
    },
  };

  handleSubmit = ({ name, blocks }) => {
    if (this.props.dirty) {
      this.props.onSubmit({
        name,
        blocks: map(blocks, (values, id) => ({
          id,
          values,
        })),
      });
    }
  };

  handleCloseRequest = () => {
    this.props.onClose(this.props.dirty, this.props.submit);
  };

  render() {
    const {
      dirty,
      invalid,
      partialExport,
      isLoading,
      isUpdating,
      onDelete,
      context,
      handleSubmit,
    } = this.props;

    /* eslint-disable jsx-a11y/anchor-is-valid */
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    /* eslint-disable jsx-a11y/no-static-element-interactions */

    return (
      <HotKeys
        styleName="inspector"
        keyMap={keyMap}
        handlers={this.keyHandlers}
      >
        <div className="concept-tab">
          <div className="left-links">
            <div className="custom-dropdown --inspect-tab inspect-features-list">
              <span className="icon icon-contexts" />
              <span className="entity-selected-name">{context.name}</span>
            </div>
            <a className="concept-tab__menu-item --active">General</a>
          </div>

          <div className="right-links">
            <a
              data-test="close-cross"
              className="concept-tab__close"
              onClick={this.handleCloseRequest}
            >
              <i className="icon-close" />
            </a>
          </div>
        </div>
        <div className="entity-inspect-wrapper">
          <div styleName="context-inspect">
            <ContextInspectHeader context={context} onDelete={onDelete} />
            <Form styleName="form" onSubmit={handleSubmit(this.handleSubmit)}>
              <ContextInspectForm
                partialExport={partialExport}
                isDirty={dirty}
                isInvalid={invalid}
                isLoading={isLoading}
                isUpdating={isUpdating}
                context={context}
              />
            </Form>
          </div>
        </div>
      </HotKeys>
    );
  }
}

const mapStateToProps = state => ({
  isUpdating: getIsUpdating(state),
  initialValues: getContextBlocksValues(state),
});

const mapDispatchToProps = {
  deselectContext,
  partialExport: partialExportSingleContext,
  checkContextName,
};

const asyncValidate = (formProps, dispatch, props) =>
  props.checkContextName('name', formProps.name, props.context.id);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  reduxForm({
    asyncValidate,
    validate,
    asyncChangeFields: ['name'],
    enableReinitialize: true,
    form: FORM_NAMES.CONTEXTS.INSPECT,
    touchOnBlur: false,
    touchOnChange: true,
  })(ContextInspect),
);
